import React from 'react'
import CareerHero from './CareerHero'
import WhyJoinUs from './WhyJoinUs'
import OpenPositions from './OpenPositions'
import Testimonial from '../Home/Testimonial'
import BookaCall from '../Home/BookaCall'

const Careers = () => {
  return (
    <>
    <CareerHero/>
    <WhyJoinUs/>
    <OpenPositions/>
    <Testimonial/>
    <BookaCall/>
    </>
  )
}

export default Careers